import React from "react";
import ProductItem from "../Common/ProductItem";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Link } from "react-router-dom";

function Products() {
    const { data } = useSelector((store) => store.products);

    return (
        <StyledSection>
            <div className="container-fluid theme-container">

                {/* Section header */}
                <SectionHeader>
                    <div className="sh-title-group">
                        <span className="sh-accent" />
                        <div>
                            <h5 className="sh-title">🔥 Deals of the Day</h5>
                            <p className="sh-sub">Best prices, every single day</p>
                        </div>
                    </div>
                    <Link to="/category" className="sh-see-all">
                        See All &nbsp;<i className="fa fa-arrow-right" />
                    </Link>
                </SectionHeader>

                {/* Grid */}
                {data && data.length > 0 ? (
                    <div className="products-grid">
                        {data.map((product) => (
                            <div key={product.id} className="products-grid-item">
                                <ProductItem product={product} />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="d-flex justify-content-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading…</span>
                        </div>
                    </div>
                )}
            </div>
        </StyledSection>
    );
}

export default Products;

/* ── Styled ── */
const StyledSection = styled.div`
    padding: 48px 0 56px;
    background: #fff;

    .products-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 22px;
    }

    @media (max-width: 991px) {
        .products-grid { grid-template-columns: repeat(2, 1fr); gap: 16px; }
    }
    @media (max-width: 575px) {
        .products-grid { grid-template-columns: 1fr; gap: 14px; }
    }
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;
    flex-wrap: wrap;
    gap: 12px;

    .sh-title-group {
        display: flex;
        align-items: center;
        gap: 14px;
    }

    .sh-accent {
        display: block;
        width: 4px;
        height: 44px;
        background: linear-gradient(180deg, #f97316, #ef4444);
        border-radius: 4px;
        flex-shrink: 0;
    }

    .sh-title {
        font-size: 20px;
        font-weight: 700;
        color: #1e293b;
        margin: 0 0 2px;
        font-family: "Poppins", sans-serif;
        letter-spacing: -0.01em;
    }

    .sh-sub {
        font-size: 12.5px;
        color: #64748b;
        margin: 0;
    }

    .sh-see-all {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        font-weight: 600;
        color: #f97316;
        border: 1.5px solid #fed7aa;
        padding: 7px 16px;
        border-radius: 20px;
        text-decoration: none;
        transition: background 0.2s ease, color 0.2s ease;
        white-space: nowrap;
        font-family: "Poppins", sans-serif;

        &:hover {
            background: #f97316;
            color: #fff;
            border-color: #f97316;
        }
    }
`;
